<template>
  <a-layout class='index animated fadeIn s_bf'>
      <SmallSquare
        content='此功能可以将二维码跟某个商品信息进行关联绑定，扫码查询页面通过关联信息显示对应商品。可按码段/批次/流水号范围绑定商品信息；同一个二维码可以重复设置在不同的赋码类型（批次/流水号）中，但系统会根据优先级调用最终的商品信息；优先级：流水号范围>批次'
        :padding='false'></SmallSquare>
      <div class="m-t-20 s_flex_bian_c">
        <div>
          <span class='mr15'>
            <a-button type="primary" v-has:productCodeCreate="()=>{$router.push({path:'/qrcode/batch/productCreate'})}">
              <PlusOutlined />
              添加商品赋码
            </a-button>
          </span>
        </div>
      </div>
      <a-form ref='form' :model='search' class="m-t-20" :initialValues="search"
        :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="创建时间" name='time'>
          <a-range-picker valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="changTime" />
        </a-form-item>
        <a-form-item label="批次" name='batch_sn'>
          <a-input v-model:value="search.batch_sn" style="width:200px" placeholder="请输入批次号进行搜索"></a-input>
        </a-form-item>
        <a-form-item label="关键词" name='keyword'>
          <a-input v-model:value="search.keyword" style="width:200px" placeholder="请输入商品ID/名称进行搜索" />
        </a-form-item>
        <a-form-item label="流水号" name='serial_sn'>
          <a-input v-model:value="search.serial_sn" style="width:200px" placeholder="请输入流水号进行搜索" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit' class='m-r-10'>搜索</a-button>
        </a-form-item>
      </a-form>
      <div class="m-t-20">
        <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns'  :data-source='data'>
          <template v-slot:product_name="{record}">
            <a-card-meta>
              <template #avatar>
                <img :src="info.picdomain+'/'+record.product_img" alt="" style="width:50px">
              </template>
              <template #description>
                <p class="s_c333">{{record.product_name}}</p>
                ID：{{record.product_id}}
              </template>
            </a-card-meta>
          </template>
          <template v-slot:small_serial_start="{ record }">
            {{record.small_serial_start}}-{{record.small_serial_end}}
          </template>
          <template v-slot:action="{ record }">
            <a-button type="link" v-has:productCodeDel='()=>del(record)'>删除</a-button>
          </template>
        </a-table>
        <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper
          :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
          @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
      </div>
  </a-layout>
</template>
<script>
  import { ExclamationCircleOutlined ,PlusOutlined} from '@ant-design/icons-vue';
  import { reactive, ref, toRefs, onMounted, inject,createVNode } from "vue";
  import { iscode } from "@/utils/app";
  import { getMemberList, getMemberTagList, getMemberVip } from "@/api/member";
  import { code_products, codeProductsDel } from '@/api/qrcode'
  import store from "@/store";
  const def = {
    page: 1,
    limit: 10,
    batch_sn: "",
    keyword: "",
    serial_sn: "",
    start_time: "",
    end_time: ""
  };
  export default {
    components: { PlusOutlined },
    setup() {
      const state = reactive({
        info: store.state.user.info,
        vipList: [],
        listLoading: false,
        total: 0,
      });
      let data = ref();
      let columns = [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "商品信息",
          dataIndex: "product_name",
          key: "product_name",
          slots: { customRender: "product_name" },
        },
        {
          title: "批次",
          dataIndex: "batch_sn",
          key: "batch_sn",
        },
        {
          title: "流水号",
          dataIndex: "small_serial_start",
          key: "small_serial_start",
          slots: { customRender: "small_serial_start" },
        },
        {
          title: "添加时间",
          dataIndex: "created_time",
          key: "created_time"
        },
        {
          title: "操作",
          dataIndex: "action",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      //获取列表
      const initData = async (values) => {
        state.listLoading = true;
        let res = await code_products(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data;
          state.total = res.meta.total;
        }
        state.listLoading = false;
      };
      const $Modal = inject('$Modal')
      // 删除标签
      const del = (e) => {
        $Modal.confirm({
          title:'温馨提示',
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          content: '删除后无法恢复,您确认要删除吗？', onOk: async () => {
            let res = await codeProductsDel(e.id).then(res => res.data);
            if (iscode(res, true)) {
              initData(search.value);
            }
          }
        })
      }
      const search = ref(def);
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      onMounted(() => {
        initData(search.value);
      
      });
      const $router = inject("$router");
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        changTime,
        del
      };
    },
  };
</script>